/**
 * Created by koqiui on 2017-04-13.
 */
import { Vue, VueRouter } from '../../app.vues'

import App from './main.vue'

//

new Vue({
    el: '#app',
    render: h => h(App)
});



//////////////////
// WEBPACK FOOTER
// ./src/entry/userLogin/main.js
// module id = 879
// module chunks = 18